<template lang="pug">
  .flow-builder-action-show-products-template
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(v-for="(platform) in selectedPlatformsObjects.slice(0, sliceEnd)", :key="platform.platform_id", :style="{'background-color': platformColor(platform.name, 0.7)}") {{ platform.title }}
      b-badge(v-if="selectedPlatformsObjects.slice(sliceEnd).length", variant="soft-secondary") {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(placeholder="- Agregar plataformas -", :options="parsedPlatforms", :disabled="disabled", :value="selected_platforms", @input="updatePlatforms", multiple, :limit="3", :searchable="false")
    b-card.mb-0.no-shadow.w-100.bg-light-white
      .bg-white.mb-3
        p.mb-0 Matcher
        p.text-secondary.text-sm Realiza una búsqueda en un arreglo de objetos.
        fieldset.mb-3(:disabled="disabled")
          b-form-group.mb-1(label-size="sm", :label="`Nivel de precisión: ${template_attribute.value * 100}%`", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'confidence'")
            b-form-input(
              type="range",
              min="0.01",
              max="1",
              step="0.01",
              :value="template_attribute.value",
              @input="updateTemplateAttribute(template_attribute, $event)"
            )
          b-form-group.mb-1(label-size="sm", label="Tipo de búsqueda:", :description="description", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'match_type'")
            b-form-select(size="sm", :value="template_attribute.value || null", @change="update(template_attribute, $event)")
              option(:value="null", disabled) Selecciona tipo
              option(v-for="(type, index) in match_types", :key="index", :value="type.value") {{type.title}}
          b-form-group.mb-1(label-size="sm", label="Arreglo de objetos:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'array'")
            vue-tribute(:options="tributeOpts")
              b-form-textarea.disabled-white(
                no-resize,
                max-rows="100",
                placeholder="Arreglo en formato JSON",
                :value="template_attribute.value",
                @blur="updateTemplateAttribute(template_attribute, $event)",
                @focusout="isJson($event)"
              )
          b-form-group.mb-2(label-size="sm", label="Valor a buscar:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'value'")
            vue-tribute(:options="tributeOpts")
              b-form-input(
                size="sm",
                placeholder="Valor a buscar",
                :value="template_attribute.value",
                @blur="updateTemplateAttribute(template_attribute, $event)"
              )
      matcher-element(v-for="element in Elements", :key="element.element_id", :id="`element_${element.element_id}`", :disabled="disabled", :block_id="block_id", v-bind="element", @destroy="destroyTemplateElement(element)")
      add-element-button.mb-3(v-if="!disabled", @click="createTemplateElement")
      template-connector(v-for="connector in Template_Connectors", :key="connector.template_connector_id", v-bind="connector", :block_id="block_id", :disabled="disabled")
</template>

<script>
import templateCommon from '@/helpers/template-common'
import TemplateTools from '@/components/templates/common/Tools.vue'
import Connector from './connectors/Connector'
import AddElementButton from '@/components/AddElementButton.vue'
import MatcherElement from './MatcherElement.vue'
import _debounce from 'lodash.debounce'

export default {
  mixins: [templateCommon],
  data () {
    return {
      match_types: [
        {value:'best_match', title: 'Best Match'},
        {value:'match', title: 'Match'},
        {value:'keyword', title: 'Keyword'},
        {value:'mix_match', title: 'Mix Match'}
      ],
    }
  },
  computed: {
    description () {
      let template_attribute = this.getAttribute('match_type')
      if (template_attribute && template_attribute.value) {
        switch (template_attribute.value) {
          case 'best_match':
            return 'Busca el objeto con el mejor nivel de precisión (arriba del establecido).'
          case 'match':
            return 'Regresa un arreglo de objetos que coincidieron con la búsqueda y nivel de precisión arriba del establecido.';
          case 'keyword':
            return 'Busca el objeto que contenga un atributo igual al elemento a buscar';
          default:
            return '';
        }
      }
      return ''
    }
  },
  components: {
    'template-connector': Connector,
    TemplateTools,
    AddElementButton,
    MatcherElement
  },
  mounted () {

  },
  created () {
    this.updateTemplateAttribute = _debounce((template_attribute, value) => {
      let newValue

      if (value && value.target) {
        newValue = value.target._value
      } else {
        newValue = value
      }

      this.update(template_attribute, newValue)

      this.$message.success('Actualizado')
    }, 100, { leading: false, trailing: true })
  },
  methods: {
    update (template_attribute, value) {
      template_attribute.value = value
      let attribute = JSON.parse(JSON.stringify(template_attribute))
      attribute.value = value
      this.updateAttribute(this.block_id, this.template_id, attribute)
    },
    destroyTemplateElement () {
      this.destroyElement(this.block_id, this.template_id, element)
    },
    createTemplateElement () {
      let element = {
        number: this.Elements.length + 1,
        type: 'matcher',
        attributes: [
          {
            name: 'object_search',
            value: ''
          }
        ]
      }

      this.createElement(this.block_id, this.template_id, element)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
